import { render, staticRenderFns } from "./PieMetric.vue?vue&type=template&id=4cd71f2b&"
import script from "./PieMetric.vue?vue&type=script&lang=js&"
export * from "./PieMetric.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports